/// <reference types="vite-plugin-svgr/client" />
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import EmptyCartLT from "@monorepo/assets/src/img/home.svg?react";
import EmptyCartPL from "@monorepo/assets/src/img/homePL.svg?react";
import { LANGUAGE } from "@monorepo/constants";
import { useActiveCartGroup } from "@monorepo/hooks";
import theme from "@monorepo/styles/theme";
import { IAttributesSliceState, LanguagesEnum } from "@monorepo/types";
import { styled } from "@mui/material";

import { PaymentsButton } from "../PaymentsButton/PaymentsButton";
import { ThirdPartyImageWrapper } from "../ThirdPartyImageWrapper/ThirdPartyImageWrapper";

interface IProps {
  showPaymentBtn: boolean;
}

const StyledEmptyCart = styled(LANGUAGE === LanguagesEnum.PL ? EmptyCartPL : EmptyCartLT)(() => ({
  maxHeight: "20rem",
  [theme.breakpoints.down("xl")]: {
    maxWidth: "100%",
    gridRow: 2,
  },
}));

const StyledFirstPaymentContent = styled("div")(() => ({
  display: "grid",
  justifyContent: "center",
  rowGap: theme.spacing(5),
}));

export const FirstPaymentContent: React.FC<IProps> = ({ showPaymentBtn }) => {
  const { t } = useTranslation();
  const thirdPartyFirstPmtImg = useSelector(
    ({ attributesSlice }: IAttributesSliceState) => attributesSlice?.["attributes-object"]
  )?.imageUrls?.firstPayment;
  const { activeCartGroup, isLoading } = useActiveCartGroup();
  const isPaymentButtonDisabled = isLoading || (!activeCartGroup?.is_owner && !Boolean(activeCartGroup?.add));

  return (
    <StyledFirstPaymentContent>
      {!!thirdPartyFirstPmtImg ? (
        <ThirdPartyImageWrapper
          component="img"
          src={thirdPartyFirstPmtImg}
          alt={t("payment_history.first_payment")}
          sx={{
            maxHeight: "20rem",
            [theme.breakpoints.down("xl")]: {
              maxWidth: "100%",
              gridRow: 2,
            },
          }}
        ></ThirdPartyImageWrapper>
      ) : (
        <StyledEmptyCart />
      )}
      {showPaymentBtn && (
        <PaymentsButton disabled={isPaymentButtonDisabled} eventName={"first_payment"}>
          {t("payment_history.first_payment")}
        </PaymentsButton>
      )}
    </StyledFirstPaymentContent>
  );
};
